export default __webpack_public_path__ + "static/media/project-one.a22c904d.png";